import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const sites = ['aandjpoolplasterllc.com', 'javierjunkremoval.com', 'northfaceirrigation.com', 'blueskycontractor.com', 'southcoastarborcare.com', 'yeimateolawncare.com', 'jezaway.com', 'iandalandscaping.com', 'josejunkremovalservice.com'];
const shot = (domain: string) => `https://image.thum.io/get/width/600/crop/1500/https://${domain}`;

// Split sites into columns, rotating the order so each column differs
const columns = [0, 1, 2, 3].map(c => sites.map((_, i) => sites[(i + c * 2) % sites.length]).slice(0, 5));
const durations = [60, 75, 55, 70];
function BrowserCard({
  domain
}: {
  domain: string;
}) {
  return <div className="rounded-xl overflow-hidden border border-white/10 bg-dark-100 shadow-2xl" data-id="element-187" data-mp="yxn4bzummzab">
      <div className="flex items-center gap-1.5 px-3 py-2 bg-dark-200 border-b border-white/5" data-id="element-188" data-mp="2gaefg8nrb17">
        <span className="w-2 h-2 rounded-full bg-white/20" data-id="element-189" data-mp="6gau147hts9u" />
        <span className="w-2 h-2 rounded-full bg-white/20" data-id="element-190" data-mp="6epzvfp3cbci" />
        <span className="w-2 h-2 rounded-full bg-white/20" data-id="element-191" data-mp="2oeght2fztufm" />
        <span className="ml-2 text-[10px] text-gray-500 truncate" data-id="element-192" data-mp="2jgwz9qc9ivhv">
          {domain}
        </span>
      </div>
      <img src={shot(domain)} alt="" loading="lazy" className="w-full h-auto block" data-id="element-193" data-mp="2ep6nrh1la1ov" />
    </div>;
}
export function HeroWebsiteReel() {
  const reduceMotion = useReducedMotion();
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-194" data-mp="24tc18au8vmgt">
      <div className="absolute left-1/2 top-1/2 w-[160%] md:w-[130%] -translate-x-1/2 -translate-y-1/2 -rotate-[8deg]" data-id="element-195" data-mp="20ovwicwdal36">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6" data-id="element-196" data-mp="1vsxb8y6c5j6z">
          {columns.map((col, c) => {
          const up = c % 2 === 0;
          return <div key={c} className={`h-[180vh] overflow-hidden ${c > 1 ? 'hidden md:block' : ''}`} data-id="element-197" data-mp="3q4llwo5jazlk" data-mpi={c}>
                <motion.div className="flex flex-col gap-5 md:gap-6" initial={{
              y: up ? '0%' : '-50%'
            }} animate={reduceMotion ? undefined : {
              y: up ? '-50%' : '0%'
            }} transition={{
              duration: durations[c],
              ease: 'linear',
              repeat: Infinity
            }} data-id="element-198" data-mp="1jgbfl1gmhpsc">
                  {[...col, ...col].map((domain, i) => <BrowserCard key={`${domain}-${i}`} domain={domain} data-id="element-199" data-mp="225i2z1sd35kh" data-mpi={i} />)}
                </motion.div>
              </div>;
        })}
        </div>
      </div>
    </div>;
}